export class Group {
  id: string;
  name: string;
  description: string;
  organizations: Array<any>;
}
